import React, { } from 'react';
import { Skeleton } from "@material-ui/lab"
import PropTypes from 'prop-types';

const SkeletonWrapper = ({children, condition}) => {
   if(condition){
      return (
         <Skeleton variant="rectangular" width="100%" height={318}>
            {children}
         </Skeleton>
      )
   }

   return <>{children}</>
}

SkeletonWrapper.propTypes = {
   children: PropTypes.node,
   condition: PropTypes.bool,
 };

 SkeletonWrapper.defaultProps = {
   children: null,
   condition: false,
 };

export default SkeletonWrapper